/*jslint browser: true, fudge: true, long: true */
/*global $, blacksunplc, dialogPolyfill, document, location, navigator, window */

blacksunplc.events.ready(function () {
    "use strict";

    var results = $(".results-container-list").data("result");

    $(".toggle-buttons li").on("click", function () {
        var btnSet = $(this).data("type");
        $(this).toggleClass("selected");
        $(this).siblings().removeClass("selected");

        $("." + btnSet).toggleClass("show").slideToggle();
        $("." + btnSet).siblings().removeClass("show").slideUp();
    });

    $(".buttons button").on("click", function () {
        $(this).toggleClass("active");

        countFilters();
        applyActiveFilters();
    });

    $(".clear").on("click", function (e) {
        e.preventDefault();

        $(".buttons button").removeClass("active");
        $(".toggle-buttons li span").text("(0)");

        setTimeout(function () {
            $(".show-results").trigger("click");
            showResults();
        }, 500)
    });

    // $(".show-results").on("click", function () {
    //     var cat;
    //     var topic;

    //     $(".results-container-list").addClass("filtered");
    //     $(".results-container-list .media-item, .load-more").hide();

    //     if ($(".buttons button.active").length === 0) {
    //         $(".results-container-list").removeClass("filtered");
    //         $(".results-container-list .media-item, .load-more").show();
    //     }

    //     if ($(".buttons .contentType button.active").length) {
    //         $(".buttons .contentType button.active").each(function () {
    //             cat = $(this).data("cat");

    //             if ($(".buttons .topicType button.active").length) {
    //                 $(".buttons .topicType button.active").each(function () {
    //                     topic = $(this).data("cat");

    //                     $("." + cat + "." + topic).show();
    //                 });
    //             } else {
    //                 $("." + cat).show();
    //             }
    //         });
    //     } else if ($(".buttons .topicType button.active").length) {
    //         $(".buttons .topicType button.active").each(function () {
    //             topic = $(this).data("cat");

    //             if ($(".buttons .contentType button.active").length) {
    //                 $(".buttons .contentType button.active").each(function () {
    //                     cat = $(this).data("cat");

    //                     $("." + cat + "." + topic).show();
    //                 });
    //             } else {
    //                 $("." + topic).show();
    //             }
    //         });
    //     }

    // });


    // function applyFiltersFromHash() {
    //     var cat;
    //     var topic;
    //     var selectedCats = [];

    //     $(".results-container-list").addClass("filtered");
    //     $(".results-container-list .media-item, .load-more").hide();

    //     if ($(".buttons button.active").length === 0) {
    //         $(".results-container-list").removeClass("filtered");
    //         $(".results-container-list .media-item, .load-more").show();
    //         window.location.hash = ""; // Clear hash if nothing is selected
    //         return; // Exit early
    //     }

    //     if ($(".buttons .contentType button.active").length) {
    //         $(".buttons .contentType button.active").each(function () {
    //             cat = $(this).data("cat");
    //             selectedCats.push(cat); // Collect selected categories

    //             if ($(".buttons .topicType button.active").length) {
    //                 $(".buttons .topicType button.active").each(function () {
    //                     topic = $(this).data("cat");
    //                     $("." + cat + "." + topic).show();
    //                 });
    //             } else {
    //                 $("." + cat).show();
    //             }
    //         });
    //     } else if ($(".buttons .topicType button.active").length) {
    //         $(".buttons .topicType button.active").each(function () {
    //             topic = $(this).data("cat");

    //             if ($(".buttons .contentType button.active").length) {
    //                 $(".buttons .contentType button.active").each(function () {
    //                     cat = $(this).data("cat");
    //                     selectedCats.push(cat); // Collect selected categories
    //                     $("." + cat + "." + topic).show();
    //                 });
    //             } else {
    //                 $("." + topic).show();
    //             }
    //         });
    //     }

    //     // Update the URL hash with all selected categories
    //     if (selectedCats.length > 0) {
    //         window.location.hash = selectedCats.join(",");
    //     }
    // }

    // $(".show-results").on("click", function () {
    //     applyFiltersFromHash();
    // });


    // var hash = window.location.hash.substring(1); // Remove the '#' symbol

    // if (hash) {
    //     // Find the button with data-cat matching the hash and activate it
    //     $(".buttons .contentType button").each(function () {
    //         if ($(this).data("cat") === hash) {
    //             $(this).addClass("active");
    //             countFilters();
    //         }
    //     });

    //     applyFiltersFromHash();
    // }


    function applyFilters(selectedCats = [], selectedTopics = []) {
        $(".results-container-list").addClass("filtered");
        $(".results-container-list .media-item, .load-more").hide();

        if (selectedCats.length === 0 && selectedTopics.length === 0) {
            $(".results-container-list").removeClass("filtered");
            $(".results-container-list .media-item, .load-more").show();
            return;
        }

        if (selectedCats.length > 0) {
            selectedCats.forEach(function (cat) {
                if (selectedTopics.length > 0) {
                    selectedTopics.forEach(function (topic) {
                        $("." + cat + "." + topic).show();
                    });
                } else {
                    $("." + cat).show();
                }
            });
        } else {
            selectedTopics.forEach(function (topic) {
                $("." + topic).show();
            });
        }
    }

    // Generic filter function for careers page (multiple filter types)
    function applyGenericFilters(filterGroups) {
        $(".results-container-list").addClass("filtered");
        $(".results-container-list .media-item, .load-more").hide();

        // Check if any filters are active
        var hasActiveFilters = Object.values(filterGroups).some(function (group) {
            return group.length > 0;
        });

        if (!hasActiveFilters) {
            $(".results-container-list").removeClass("filtered");
            $(".results-container-list .media-item, .load-more").show();
            return;
        }

        // Show items that match ALL active filter groups (AND logic between groups)
        $(".results-container-list .media-item").each(function () {
            var $item = $(this);
            var matchesAll = true;

            Object.keys(filterGroups).forEach(function (groupKey) {
                var groupFilters = filterGroups[groupKey];
                if (groupFilters.length > 0) {
                    var matchesGroup = groupFilters.some(function (filter) {
                        return $item.hasClass(filter);
                    });
                    if (!matchesGroup) {
                        matchesAll = false;
                    }
                }
            });

            if (matchesAll) {
                $item.show();
            }
        });
    }

    function applyActiveFilters() {
        // Check if we're on careers page
        var isCareersPage = $(".careers-filters").length > 0;

        if (isCareersPage) {
            var filterGroups = {
                location: [],
                agency: [],
                role: []
            };

            $(".buttons .locationType button.active").each(function () {
                filterGroups.location.push($(this).data("cat"));
            });

            $(".buttons .agencyType button.active").each(function () {
                filterGroups.agency.push($(this).data("cat"));
            });

            $(".buttons .roleType button.active").each(function () {
                filterGroups.role.push($(this).data("cat"));
            });

            applyGenericFilters(filterGroups);
        } else {
            // Original our-thinking logic
            var selectedCats = [];
            var selectedTopics = [];

            $(".buttons .contentType button.active").each(function () {
                selectedCats.push($(this).data("cat"));
            });

            $(".buttons .topicType button.active").each(function () {
                selectedTopics.push($(this).data("cat"));
            });

            // Update hash
            if (selectedCats.length > 0) {
                window.location.hash = selectedCats.join(",");
            } else {
                window.location.hash = "";
            }

            applyFilters(selectedCats, selectedTopics);
        }
    }

    // Removing manual show-results button listener as it's now automated
    // $(".show-results").on("click", function () { ... });


    var hash = window.location.hash.substring(1);
    var selectedCats = hash ? hash.split(",") : [];

    // Activate buttons based on hash
    $(".buttons .contentType button").removeClass("active");
    selectedCats.forEach(function (cat) {
        $(".buttons .contentType button").each(function () {
            if ($(this).data("cat") === cat) {
                $(this).addClass("active");
                setTimeout(function () {
                    applyActiveFilters();
                }, 0);
            }
        });
    });

    applyFilters(selectedCats, []);
    countFilters();

    $(".sort").on("click", function () {
        $(this).toggleClass("active");
    });

    $(".sort li").on("click", function () {
        $(this).addClass("selected");
        $(this).siblings().removeClass("selected");
    });

    $("body").on("click", ".load-more", function () {
        if ($('body').hasClass('game-changers-page')) {
            results += 7;
            showResults();
        }
    });

    if ($(".related-content-list").length) {
        $(".related-content-list").slick({
            slidesToShow: 4,
            responsive: [{
                breakpoint: 1181,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            }]
        });
    }
    if ($(".article-carousel__list").length) {
        $(".article-carousel__list").slick({
            slidesToShow: 1,
        });
    }
    $(window).on("scroll", function () {
        stickyAuthorDetails();
        revealOnScroll();
    });

    showResults();
    stickyAuthorDetails();

    $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top + 200;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    function stickyAuthorDetails() {
        if ($(".personprofile").length) {
            var scrollPos = $(document).scrollTop();
            var articleContainer = $(".banner-container +  .container .main-section");
            var articleHeight = articleContainer.offset().top + articleContainer.outerHeight() - 1000;

            if (scrollPos > articleHeight) {
                $(".personprofile").addClass("static");
            } else {
                $(".personprofile").removeClass("static");

            }
        }
    }

    function showResults() {
        $(".results-container-list .media-item").each(function (key, val) {
            if (key + 1 <= results) {
                $(this).slideDown();
            } else {
                $(this).hide();
            }
        });

        if (results >= $(".results-container-list .media-item").length) {
            $(".load-more").hide();
        }
    }

    function countFilters() {
        var count;
        var type;

        $(".buttons > div").each(function () {
            count = $(this).find(".active").length;
            type = $(this).attr("class").split(" ")[0];

            $(".toggle-buttons li[data-type=" + type + "] span").text("(" + count + ")");
        });
    }

    function revealOnScroll() {
        const elementList = [
            ".main-section >.cmp-container > .container > .cmp-container > .container > .cmp-container .cmp-text",
            ".main-section >.cmp-container > .container > .cmp-container > .container > .cmp-container .button",
            ".article-page.privacy-policy-page .article-content .writeup*",
            ".article-page.qa-page .article-content .writeup*"
        ].join(", ");
        $(elementList).each(function () {
            $(this).find(">*").each(function () {
                if ($(this).isInViewport()) {
                    $(this).addClass("reveal");
                }
            });
        });

        if ($(".related-content").length > 0 && $(".related-content").isInViewport()) {
            $(".related-content").addClass("reveal");
        }
    }
});
